import axios from "axios";

// usePost에서 사용
const client = axios.create({
    baseURL: "https://api.contact.plus-ex.com",
});

export default client;
